export default theme => ({
  list: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: -3,
  },

  item: {
  },

  itemIcon: {
    color: '#fff',
    display: 'block',
    width: 32,
    height: 32,
    textAlign: 'center',
    fontSize: 16,
    margin: 0
  },

  iconAparat: {
    background: 'url(http://www.aparat.com/public/public/images/logo/v2/aparat_icon_color_black_64.png)',
    backgroundSize: '24px 24px',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#d7d7d7',
    backgroundPosition: 'center center',
    // border: '1px solid #000',
    // borderLeft: 0,
  },
  iconTelegram: {
    paddingTop: 6,
    background: '#08c',
    '&:hover': {
      background: '#1ab3ff'
    }
  },
  iconFacebook: {
    paddingTop: 6,
    background: '#3b5998',
    '&:hover': {
      background: '#5f7ec1'
    }
  },
  iconInstagram: {
    paddingTop: 6,
    background: '#c13584',
    '&:hover': {
      background: '#d76ca8'
    }
  },
});